<!-- Dialog Header -->
<div mat-dialog-title>
  <span>
    {{ 'Carica file' | siaTranslate }}
  </span>
  <mat-icon
    mat-button
    mat-dialog-close
    (click)="closeDialog()"
    class="sia-dialog-close-button flex"
  >
    close
  </mat-icon>
</div>

<!-- Dialog Content -->
<div
  mat-dialog-content
  class="!flex min-h-[300px] flex-col justify-center gap-4 py-6"
>
  <!-- Custom File Input -->
  <div class="relative h-fit w-full">
    <label
      for="file-upload"
      class="surface group flex min-h-[120px] cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-[var(--mat-sys-outline)] px-6 py-8 text-center transition-all duration-200 hover:!border-ai-shade-2 hover:!bg-ai-shade-1 hover:text-ai-on-shade"
      [class.border-ai-shade-2]="selectedFile || isDragOver"
      [class.bg-ai-shade-1]="selectedFile || isDragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <div class="flex flex-col items-center space-y-2">
        <div class="">
          <mat-icon class="h-6 w-6">
            {{ selectedFile ? 'check_circle' : 'cloud_upload' }}
          </mat-icon>
        </div>

        <div class="space-y-1">
          @if (isDragOver) {
            <p class="text-sm font-medium">
              {{ 'Rilascia il file qui' | siaTranslate }}
            </p>
          } @else if (!selectedFile) {
            <p class="text-sm font-medium">
              {{ 'Clicca per selezionare un file' | siaTranslate }}
            </p>
          } @else {
            <p class="text-sm font-semibold">
              {{ selectedFile.name }}
            </p>
            <p class="text-xs">
              {{ formatFileSize(selectedFile.size) }}
            </p>
          }
          @if (!selectedFile && !isDragOver) {
            <p class="text-xs">
              {{ 'o trascina e rilascia qui' | siaTranslate }}
            </p>
          }
        </div>
      </div>

      <input
        id="file-upload"
        type="file"
        class="sr-only"
        (change)="onFileSelected($event)"
        accept="*/*"
      />
    </label>
  </div>

  <!-- File Info -->
  @if (selectedFile) {
    <div class="surface rounded-md border p-3">
      <div class="flex items-center space-x-3">
        <mat-icon class="mt-0.5">description</mat-icon>
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium">
            {{ selectedFile.name }}
          </p>
          <p class="mt-1 text-xs">
            {{ 'Dimensione' | siaTranslate }}:
            {{ formatFileSize(selectedFile.size) }}
          </p>
          <p class="text-xs">
            {{ 'Tipo' | siaTranslate }}:
            {{ selectedFile.type || ('Non specificato' | siaTranslate) }}
          </p>
        </div>
      </div>
    </div>
  }
</div>

<!-- Dialog Actions -->
<div mat-dialog-actions align="end">
  <button
    mat-button
    color="primary"
    class=""
    [disabled]="!selectedFile || isUploading"
    (click)="uploadFile()"
  >
    <mat-icon class="h-4 w-4">upload</mat-icon>
    @if (isUploading) {
      <span>{{ 'Caricamento...' | siaTranslate }}</span>
    } @else {
      <span>{{ 'Carica File' | siaTranslate }}</span>
    }
  </button>
  <button mat-button class="" (click)="closeDialog()">
    {{ 'Annulla' | siaTranslate }}
  </button>
</div>
